import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import SearchInput from '../SearchInput';
import AccountPicker from '../AccountPicker';
import { MAIN_NAVLINKS } from '../../constants/Navigation';

const drawerWidth = '18.75rem';
function AccountAnchor({ onSearch, handleOpenDrawer }) {
	const theme = useTheme();
	const { t } = useTranslation('account_anchor', 'common');
	const { pathname } = useLocation();

	return (
		<AppBar
			position="fixed"
			inputpros={{
				'aria-label': 'Account',
				role: 'toolbar',
				'aria-controls': 'textarea1',
			}}
			sx={{
				width: { sm: `calc(100% - ${drawerWidth}px)` },
				backgroundColor: theme.palette.base.light,
				boxShadow: 'none',
				borderBottom: `1px solid ${theme.palette.base.border}`,
				height: {
					xs: '3.5rem',
					sm: '3.75rem',
					md: '4rem',
				},
			}}
		>
			<Toolbar
				inputpros={{
					'aria-label': 'Account',
					role: 'toolbar',
					'aria-controls': 'textarea1',
				}}
			>
				<Box sx={{ width: 50 }}>
					<BottomNavigation
						aria-label="Account button navigation"
						role="button"
						showLabels
						onClick={handleOpenDrawer}
					>
						<BottomNavigationAction
							aria-label="Account button"
							role="button"
							color="inherit"
							label="Menu"
							icon={
								<MenuIcon
									aria-label="clear icon button"
									role="graphics-symbol"
								/>
							}
						/>
					</BottomNavigation>
				</Box>
				<Box sx={{ marginLeft: { xs: '3rem', md: '16rem' } }}>
					<Typography
						tabIndex={0}
						sx={{
							mt: theme.spacing(0.5),
							color: theme.palette.base.contrastText,
						}}
						variant="subtitle1"
					>
						{t(MAIN_NAVLINKS.find((link) => link.href === pathname)?.label)}
						{pathname.includes('/orders/') ? t('order_details') : ''}
						{pathname.includes('/products/') ? t('product_details') : ''}
					</Typography>
				</Box>
				<Box sx={{ flexGrow: 1 }} />
				<Divider
					tabIndex={-1}
					role="presentation"
					orientation="vertical"
					flexItem
					sx={{
						margin: `${theme.spacing(0)} ${theme.spacing(2)}`,
						display: { xs: 'none', md: 'flex' },
					}}
				/>
				<Box
					sx={{
						display: { xs: 'none', sm: 'none', md: 'flex' },
						width: 'auto',
					}}
				>
					<SearchInput onSearch={onSearch} />
				</Box>
				<Divider
					orientation="vertical"
					tabIndex={-1}
					role="presentation"
					flexItem
					sx={{
						margin: `${theme.spacing(0)} ${theme.spacing(2)}`,
						display: { xs: 'none', md: 'flex' },
					}}
				/>
				<AccountPicker />
			</Toolbar>
		</AppBar>
	);
}

AccountAnchor.propTypes = {
	onSearch: PropTypes.func.isRequired,
	handleOpenDrawer: PropTypes.func.isRequired,
};

export default AccountAnchor;
